export default "__VITE_ASSET__9a401faa__"